import { useEffect, useRef, useState } from 'react';
import { today, labelMap } from '../../../utils/utils';
import Tooltip from '../../Tooltip/Tooltip';

const FormInput = (props) => {

  const labelElement = <label className="label" htmlFor={props.name}>{labelMap[props.name]}</label>;

  const inputRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);


  const inputElement = () => {
    switch (props.type) {
      case 'select':
        return (
          <select
            ref={inputRef}
            className="input"
            id={props.name}
            name={props.name}
            value={props.values[props.name]}
            disabled={props.disabled}
            onChange={(e) => props.action(props.name, inputRef.current ? inputRef.current.value : '')}
          >
            {props.defaultOption && (
              <option key='DEFAULT' value='DEFAULT'>
                Seleziona...
              </option>
            )}

            {props.options.map(option => (
              <option key={option.id} value={option.id}>
                {option.description}
              </option>
            ))}
          </select>
        )
      case 'textarea':
        return (
          <textarea
            ref={inputRef}
            className="input textarea"
            id={props.name}
            name={props.name}
            value={props.values[props.name]}
            maxLength={props.maxLength}
            onChange={(e) => props.action(props.name, inputRef.current ? inputRef.current.value : '')}
          />
        );
      case 'checkbox':
        return (
          <input
            ref={inputRef}
            type={props.type}
            className="input-checkbox"
            id={props.name}
            name={props.name}
            value={props.values[props.name]}
            checked={props.values[props.name]}
            onChange={(e) => props.action(props.name, e.target.checked)}
          />
        );
        case 'multiselect':
          return (
            <div className="multiselect-wrapper" ref={inputRef}>
              <div
                className="input"
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                <div>
                {props.values[props.name]?.length
                ? props.options
                    .filter((opt) => props.values[props.name].includes(opt.id))
                    .map((opt) => opt.description)
                    .join(', ')
                : 'Seleziona...'}
                </div>

                <i className="nexi-icon-caret_down"></i>
              </div>

              {dropdownOpen && (
                <div className="container-dropdown">
                  <label className="label-choice">
                    <input
                      type="checkbox"
                      className="input-checkbox"
                      checked={
                        props.values[props.name]?.length === props.options.length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          const allOptions = props.options.map((opt) => opt.id);
                          props.action(props.name, allOptions);
                        } else {
                          props.action(props.name, []);
                        }
                      }}
                    />
                    {props.values[props.name]?.length === props.options.length
                      ? 'Deseleziona tutto'
                      : 'Seleziona tutto'}
                  </label>

                  {props.options.map((option) => (
                    <label key={option.id} className="label-choice">
                      <input
                        type="checkbox"
                        className="input-checkbox"
                        checked={props.values[props.name]?.includes(option.id)}
                        onChange={(e) => {
                          const selected = props.values[props.name] || [];
                          let updated;
                          if (e.target.checked) {
                            updated = [...selected, option.id];
                          } else {
                            updated = selected.filter((id) => id !== option.id);
                          }
                          props.action(props.name, updated);
                        }}
                      />
                      {option.description}
                    </label>
                  ))}
                </div>
              )}
            </div>
          );

      default:
        return (
          <input
            ref={inputRef}
            className="input"
            id={props.name}
            name={props.name}
            type={props.type}
            min={props.type === 'date' ? today() : undefined}
            value={props.values[props.name] || ''}
            maxLength={props.maxLength}
            onKeyPress={(e) => {
              if ((props.isNumeric && /\D/.test(e.key)) || (props.maxLength && e.target.value.length >= props.maxLength)) e.preventDefault();
              if ((props.isAlphaNumeric && !/^[a-zA-Z0-9\s]/.test(e.key)) || (props.maxLength && e.target.value.length >= props.maxLength)) e.preventDefault();
              if ((props.isAlphabetic && !/^[a-zA-Z\s]/.test(e.key)) || (props.maxLength && e.target.value.length >= props.maxLength)) e.preventDefault();
            }}
            onChange={(e) => props.action(props.name, inputRef.current ? inputRef.current.value : '')}
          />
        )
    }
  }

  return (
    !props.hide &&
    <>
    {props.type === 'checkbox' ?
    <div className="checkbox-wrapper">
       {labelElement}
       {inputElement()}
    </div>
    :
    <div className="input-wrapper">
      {labelElement}
      {inputElement()}
      {props.tooltip && <Tooltip message={props.tooltip}/>}
    </div>
    }
    </>
  );
};

export default FormInput;